import { useQuery } from "react-query";
import { getFaqCategories } from "../api";
import { API_KEY_GET_FAQ_CATEGORIES } from "../constants";

export const useGetFaqCategories = () => {
  return useQuery([API_KEY_GET_FAQ_CATEGORIES], () => getFaqCategories());
};
